import classes from './ClinicalDiagnosis.module.css';

const Surgery = (props) => {
  const data = props.value || { value: 'N/A', classification: 'N/A' };
  const index = props.index || 'N/A';

  return (
    <div className={`${classes.inline} ${classes.row} ${classes.section}`}>
      <h4 className={classes.title}>{index}. Ngoại khoa:</h4>
      <div>{data.value}</div>
      <div>Phân loại: {data.classification}</div>
    </div>
  );
};

export default Surgery;
